import { useQuery } from '@tanstack/react-query';
import { METHOD, sendJSONRequest } from '@/state/http-request.helpers.ts';
import { useAuth } from '@clerk/clerk-react';
import type { VmAdminListResponse, VmAdminListItem } from '@/types/dtos/vm/response/vm-admin.dto';

export const LIST_VMS_QUERY_KEY = 'list-vms-admin';

export const useListVmsQuery = () => {
  const { getToken } = useAuth();

  return useQuery({
    queryKey: [LIST_VMS_QUERY_KEY],
    queryFn: async () => {
      const token = await getToken();
      return listAllVms(token ?? '');
    },
    retry: false,
    staleTime: 30_000,
    refetchOnWindowFocus: false,
  });
};

export function filterVmsByStatus(items: VmAdminListItem[], status: string): VmAdminListItem[] {
  if (!status) return items;
  return items.filter((vm) => vm.status === status);
}

const PAGE_SIZE = 100; // backend maximum

const listAllVms = async (token: string): Promise<VmAdminListItem[]> => {
  const items: VmAdminListItem[] = [];
  let page = 1;

  while (true) {
    const url = `${import.meta.env.VITE_API_URL}/vm?page=${page}&pageSize=${PAGE_SIZE}`;
    const response = (await sendJSONRequest({ url, method: METHOD.GET, token })) as VmAdminListResponse;
    items.push(...response.items);
    if (items.length >= response.total) break;
    page++;
  }

  return items;
};
